export const config = {
    apiKey: "AIzaSyB4QJtV-u6w1or0Cq_MH2aAHuk6RAG0TwI",
    authDomain: "dapp-7936d.firebaseapp.com",
    projectId: "dapp-7936d",
    storageBucket: "dapp-7936d.appspot.com",
    messagingSenderId: "921110142433",
    appId: "1:921110142433:web:003d590912b5e052b206a0",
    measurementId: "G-YVJ6L7EQD3"
  };
  